
import { Component, Mixins } from "vue-property-decorator";
import { INaturalTextBehavior } from "../../../../../../documaker/domain/format/objects";
import { INaturalTextBehaviorPropertyEditable, instanceOfINaturalTextBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class NaturalTextBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: INaturalTextBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: INaturalTextBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isNaturalTextBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfINaturalTextBehaviorPropertyEditable(s) && s.naturalTextBehavior().isEditable(), false);
  }

  get naturalTextBehavior(): INaturalTextBehavior {
    return this.readPropertyOrDefault(s => s.naturalTextBehavior().getValue(), { text: "", isEnable: false });
  }

  set naturalTextBehavior(value: INaturalTextBehavior) {
    this.writePropertyWhenValid(s => s.naturalTextBehavior().setValue(value));
  }
}
